@if (model && model.organizationId) {
    @if (isLoading) {
        <div class="fancy-loader"></div>
    } @else {
        <control-linkable
            #linkable
            displayValueProp="name"
            [linked]="linked"
            [unlinked]="unlinked"
            [hideActions]="true"
            [orderByValueProperty]="true"
            (linkedChange)="linkedChanged($event)"
            [disabled]="!permissions.canLinkControls"
        >
        </control-linkable>
    }
} @else {
    <div>{{ 'selectOrganizationFirst' | t }}</div>
}
